import React, { Component } from "react"
import CollapsibleList from './collapsible.js'
import RightTable from './rightTable.js'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import store from "./store/index"
import { getTimeDiffInMins } from "./support.js"
import moment from 'moment';
import { getRealTimeinHHMMFormat } from "./support.js"
import { updateBetMarket } from "./actions";


import axios from 'axios';

const API2 = 'https://rpmapigreyhound.makebettinggreat.com/v1/greyhound/odds';
const API_WINNER = 'https://rpmapigreyhound.makebettinggreat.com/v1/greyhound/winners/';
const headStyle1 = {
  color: 'white',
  fontSize: '20px',
  marginLeft: '20px',
  fontfamily: 'Segoe UI'
};

const anyClass = {
  height: '150px',
  overflowy: 'scroll'
}
const verAlign = {
  margin: 'auto',
  width: '100%',
  height: '100%',
  border: '3px solid #73AD21',
  color: 'white'

}

var responseBody = {
  "marketOdds": []
}

const currentRaceProps = {
  curRace: null,
  curRacers: null,
}

const postRequestPara = {
  "marketIds": [
    "1.156717370"
  ],
  "timePoints": [
    "t1-20190329-13:55:00",
    "t2-20190329-14:10:00",
    "t3-20190329-14:40:00",
    "t4-20190329-14:45:00",
    "t5-20190329-14:50:00",
    "t6-20190329-14:55:00"
  ]
}

class CurrencyBoard extends Component {
  defaultTimer = 15000;
  winnerTimerSetting = 60000;
  highSpeedTimer = 3000;
  timer = null;
  winnerTimer = null;
  intensiveMode = false;
  INTENSE_MINUTE_SETTING = 3;

  constructor(props) {
    super(props)
    this.state = {
      currentRace: { time: "", venue: "" },
      currentRacers: {},
      runnersOddsAtTimes: [],
      winnerInfo: null,
      marketId:null
    }
    this.updateBoards = this.updateBoards.bind(this)
    this.getRunnerName = this.getRunnerName.bind(this)
    this.requestTimeOdds = this.requestTimeOdds.bind(this)
    this.requestWinnerInfo = this.requestWinnerInfo.bind(this)

    if (props.tabSelected === "RacesNRunners") {
      if (currentRaceProps.curRace !== null) {
        this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
        this.requestWinnerInfo(currentRaceProps.curRace)
      }
      this.timer = setInterval(() => {
        //console.log("Recursive running the table loading");
        if (currentRaceProps.curRace != null) {
          this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
        }
      }, this.defaultTimer)

      this.winnerTimer = setInterval(() => {
       // console.log("Recursive running the table loading");
        if (currentRaceProps.curRace != null) {
          this.requestWinnerInfo(currentRaceProps.curRace)
        }
      }, this.winnerTimerSetting)
    } else {
      if (this.timer !== null) clearInterval(this.timer)
      if (this.winnerTimer !== null) clearInterval(this.winnerTimer)
    }
  }


  updateBoards(newEle) {
    //console.log("Update Boards called " + newEle);
    this.setState(prevState => ({
      boards: [...prevState.boards, newEle]
    }))
  }

  getRunnerName(selectionId, curenntRacers) {
    var name = "Unknown"
    curenntRacers.map(runner => {
      //console.log("Runner TH Name " + runner.runnerName)
      //console.log("Runner TH selectionId " + runner.selectionId)

      if (runner.selectionId == selectionId) {
        //log("Runner THHHHH Name " + runner.runnerName)
        name = runner.runnerName
      }
    }
    )
    return name
  }

  getRunnerMetadata(selectionId, curenntRacers) {
    var name = null
    curenntRacers.map(runner => {
      if (runner.selectionId == selectionId) {
        name = runner.metadata
      }
    }
    )
    return name
  }

  getTimeDiffInMins(timeDiff) {
    var hours = parseInt(timeDiff.substring(0, 2))
    var mints = parseInt(timeDiff.substring(3, 5))

    return (hours * 60 + mints)

  }

  requestWinnerInfo = currentRace => {
    const endpoint = API_WINNER + currentRace.date + "/" + currentRace.marketId
    //console.log(`requestWinnerInfo: ${endpoint}`)
    axios.get(endpoint)
        .then((res) => {
          //console.log("requestWinnerInfo. Result of API Winner ::" + res.data)
          responseBody = res.data
          const currentState = { ...this.state }
          currentState.winnerInfo = responseBody
          currentState.marketId = currentRace.marketId
          this.setState(currentState)
        },
          (error) => {
            console.log("requestWinnerInfo. Error occurred when reading Winner info")
          });
  }

  requestTimeOdds(currentRace, currentRacers) {
    var th = this;
    let TObj = {}

    Object.keys(store.getState().isExactTimeSelected).map(timeEle => {
      if (store.getState().isExactTimeSelected[timeEle] == "exact") {
        TObj[timeEle] = moment(store.getState().exactTimeSettings[timeEle], 'HH:mm').format('YYYYMMDD-HH:mm:ss');
      }
      else if (store.getState().isExactTimeSelected[timeEle] == "diff") {
        TObj[timeEle] = moment(store.getState().currentRaceTime, 'YYYYMMDD HH:mm').subtract(parseInt(this.getTimeDiffInMins(store.getState().timeSettings[timeEle])), 'minutes').format('YYYYMMDD-HH:mm:ss');
      }
    }
    )

    var timePointsArray = ["t1-" + TObj.t1, "t2-" + TObj.t2, "t3-" + TObj.t3, "t4-" + TObj.t4, "t5-" + TObj.t5, "t6-" + TObj.t6]

    const requiredLatestTimeStamp = moment(store.getState().currentRaceTime, 'YYYYMMDD HH:mm').subtract(parseInt(store.getState().latestOddsSettings.noOfSeconds), 'seconds').format('YYYYMMDD-HH:mm:ss');

    postRequestPara.marketIds = [currentRace.marketId]
    postRequestPara.timePoints = timePointsArray
    postRequestPara.tickUntilKickoff = store.getState().latestOddsSettings.tickUntilActualStart === "yes" ? true : false
    postRequestPara.latestTimeStamp = requiredLatestTimeStamp
    //console.log("Time point array : " + timePointsArray);
    //console.log("Market ID : " + postRequestPara.marketIds)
    //console.log("tickUntilKickoff : " + postRequestPara.tickUntilKickoff)
    //console.log("latestTimeStamp : " + postRequestPara.latestTimeStamp)
    window.postRequest = postRequestPara

    this.serverRequest =
      axios.post(API2, postRequestPara)
        .then((res) => {
          //console.log("Result of API 2 ::" + res.data)
          responseBody = res.data
          window.response = res.data
          let allArray = this.getMarketOddsForTimesTest(currentRacers)
          window.allArray = allArray
          this.setState({
            currentRace: {
              ...currentRace,
              latestOddTimestamp: window.latestOddTimestamp
            },
            currentRacers: currentRacers,
            runnersOddsAtTimes: allArray,
          })
        },
          (error) => {
            let allArray = this.getMarketOddsForTimesTest(currentRacers)
            this.setState({
              currentRace: {
                ...currentRace,
                latestOddTimestamp: window.latestOddTimestamp
              },
              currentRacers: currentRacers,
              runnersOddsAtTimes: allArray,
            })

          });
  }

  getMarketOddsForTimesTest(currentRacers) {

    var temp = {}
    var runnerName = ""
    var selectionId = ""
    var runnerMetaData = {}
    var toOdds = []
    var toOdds_tmp = []
    toOdds_tmp = [responseBody.marketOdds[0].t0.runnerOdds][0]
    window.latestOddTimestamp = responseBody.marketOdds[0].t0.timeStamp;

    toOdds_tmp.forEach(function (odd) {
      if (odd.bestBackOdd === null) {
        toOdds.push(odd);
      } else {
        toOdds.unshift(odd);
      }
    });

    toOdds.sort((a, b) => (a.bestBackOdd != null ? a.bestBackOdd : Infinity) - (b.bestBackOdd != null ? b.bestBackOdd : Infinity))

    //toOdds.sort((a, b) => (a.bestBackOdd === null) ? 1 : -1)
    //toOdds.sort((a, b) => (a.bestBackOdd > b.bestBackOdd) ? 1 : -1)

    window.toOdds = toOdds
    //console.log("Sorted time slots :: " + toOdds[0].bestBackOdd)
    //console.log("getMarketOddsForTimesTest: " + window.latestOddTimestamp)

    toOdds.map((item, key) => {
      //console.log("Runner Odd : selectionId : " + item.selectionId + " bestBackOdd :" + item.bestBackOdd)
      runnerName = this.getRunnerName(item.selectionId, currentRacers)
      runnerMetaData = this.getRunnerMetadata(item.selectionId, currentRacers)
      temp[item.selectionId] = {}
      temp[item.selectionId].currentPrice = item.bestBackOdd
      temp[item.selectionId].volumeMatched = item.volumeMatched
      //console.log("Runner Name set :: " + runnerName);
      temp[item.selectionId].name = runnerName
      temp[item.selectionId].metadata = runnerMetaData
      temp[item.selectionId].status = item.status
      temp[item.selectionId].selectionId = item.selectionId
    })

    let times = ["t1", "t2", "t3", "t4", "t5", "t6"]
    times.map(tVal => {
      if (responseBody.marketOdds[0][tVal] != null) {
        responseBody.marketOdds[0][tVal].runnerOdds.map(runnerOdd => {
          if (runnerOdd.bestBackOdd != null) {
            temp[runnerOdd.selectionId][tVal + 'Price'] = runnerOdd.bestBackOdd
            temp[runnerOdd.selectionId][tVal] = parseInt((runnerOdd.bestBackOdd - temp[runnerOdd.selectionId].currentPrice) * 100 / runnerOdd.bestBackOdd) + '%'
          } else {
            //console.log("Best back odd is null .");
            temp[runnerOdd.selectionId][tVal + 'Price'] = "n/a"
            temp[runnerOdd.selectionId][tVal] = 'n/a'
          }
        })
      } else {
        responseBody.marketOdds[0].t0.runnerOdds.map(runnerOdd => {
          //console.log("Runner Null Odd :  TVal" + tVal + " Selection ID:" + runnerOdd.selectionId)
          temp[runnerOdd.selectionId][tVal + 'Price'] = "n/a"
          temp[runnerOdd.selectionId][tVal] = 'n/a'
        })
      }
    })

    //console.log("EREE " + this.state.runnersOddsAtTimes)
    var finalOdds = []

    Object.keys(temp).map(runnerElement =>
      finalOdds.push(temp[runnerElement])
    )

    finalOdds.sort((a, b) => (a.currentPrice != null ? a.currentPrice : Infinity) - (b.currentPrice != null ? b.currentPrice : Infinity))

    window.myStateObject = finalOdds
    return finalOdds
  }

  componentDidUpdate() {
    if (currentRaceProps.curRace != null) {
      //console.log("componentDidUpdate: " + currentRaceProps.curRace.date + ":" + currentRaceProps.curRace.time + " : " + this.props.tabSelected);
      const currentGmtTime = moment();
      const raceTimeGmt = moment((currentRaceProps.curRace.date + " " + currentRaceProps.curRace.time), 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes');
      const timeDiffInMin = (raceTimeGmt.unix() - currentGmtTime.unix()) / 60
      const switchToIntensiveMode = (timeDiffInMin < this.INTENSE_MINUTE_SETTING) && (timeDiffInMin > 0);
      //console.log(`componentDidUpdate: currentGmtTime: ${currentGmtTime}, raceTimeGmt: ${raceTimeGmt}, switchToIntensiveMode: ${switchToIntensiveMode}, currentModeIntensive: ${this.intensiveMode}, timeDiffInMin: ${timeDiffInMin}`);
      if (this.props.tabSelected === "RacesNRunners") {
        if (switchToIntensiveMode && !this.intensiveMode) {
          //Enter intensive mode
          this.intensiveMode = true;
          clearInterval(this.timer);
          this.timer = setInterval(() => {
            //console.log("Recursive running the table loading with default mode");
            if (currentRaceProps.curRace != null) {
              this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
            }
          }, this.highSpeedTimer)
        }else if (switchToIntensiveMode && this.intensiveMode) {
            //Do nothing altready running in intensive mode
        } else if (!switchToIntensiveMode && this.intensiveMode) {
          this.intensiveMode = false;
          clearInterval(this.timer);
          this.timer = setInterval(() => {
            //console.log("Recursive running the table loading with intensive mode");
            if (currentRaceProps.curRace != null) {
              this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
            }
          }, this.defaultTimer)
        } else {
          clearInterval(this.timer);
          this.timer = setInterval(() => {
            //console.log("Recursive running the table loading with default mode");
            if (currentRaceProps.curRace != null) {
              this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
            }
          }, this.defaultTimer)
        }
      } else {
        if (this.timer !== null) clearInterval(this.timer)
      }
    }
  }

  updateStateOfBoards = (curRace, curRacers) => {
    window.currentRace = curRace
    //console.log("updateStateOfBoards : " + curRace)
    currentRaceProps.curRace = curRace
    currentRaceProps.curRacers = curRacers
    this.setState({
      currentRace: [],
      currentRacers: [],
      runnersOddsAtTimes: [],
      winnerInfo: null
    })

    if (currentRaceProps.curRace != null) {
      this.requestTimeOdds(currentRaceProps.curRace, currentRaceProps.curRacers)
      this.requestWinnerInfo(currentRaceProps.curRace)
    }
    store.dispatch(updateBetMarket({ "marketId": curRace.marketId, "type": 'Win' }));
  }


  render() {


    var element1 = { firstCurrency: "sdsd", firstVal: "20", secondCurrency: "YUAN", secondVal: "245" }

    let t1 = store.getState().isExactTimeSelected.t1 == "exact" ? getRealTimeinHHMMFormat("t1") : getTimeDiffInMins(store.getState().timeSettings.t1) + " mins before start race"
    let t2 = store.getState().isExactTimeSelected.t2 == "exact" ? getRealTimeinHHMMFormat("t2") : getTimeDiffInMins(store.getState().timeSettings.t2) + " mins before start race"
    let t3 = store.getState().isExactTimeSelected.t3 == "exact" ? getRealTimeinHHMMFormat("t3") : getTimeDiffInMins(store.getState().timeSettings.t3) + " mins before start race"
    let t4 = store.getState().isExactTimeSelected.t4 == "exact" ? getRealTimeinHHMMFormat("t4") : getTimeDiffInMins(store.getState().timeSettings.t4) + " mins before start race"
    let t5 = store.getState().isExactTimeSelected.t5 == "exact" ? getRealTimeinHHMMFormat("t5") : getTimeDiffInMins(store.getState().timeSettings.t5) + " mins before start race"
    let t6 = store.getState().isExactTimeSelected.t6 == "exact" ? getRealTimeinHHMMFormat("t6") : getTimeDiffInMins(store.getState().timeSettings.t6) + " mins before start race"

    //console.log(" current race time " + this.state.currentRace["time"] + " venue " + this.state.currentRace["venue"]);
    return (
      <div class="backcolr">
        <Row className="MiddleRow">
          <Col style={{ paddingRight: '0px', paddingLeft: '10px' }} sm={2}>
            <CollapsibleList updateBoards={this.updateStateOfBoards.bind(this)} selectedDate={this.props.selectedDate} />
          </Col>
          <Col style={{ paddingRight: '10px', paddingLeft: '0px' }} sm={10}>
            <Row className="SecondMiddleRow" style={{marginLeft: '0', marginRight: '0'}}>
              <Col style={{ paddingRight: '0', paddingLeft: '0' }}>
                <div class="divStyle10 boxSize3 borderStyle">

                  <RightTable winnerInfo={this.state.winnerInfo} 
                  marketId={this.state.marketId}
                  firstItem={this.state.currentRace} 
                  secondItem={this.state.runnersOddsAtTimes} 
                  displayTicks={this.props.displayTicks}
                  displayResult={this.props.displayResult} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div class="divStyle10 boxSize4 borderStyle">
                  <Row className="ThirdMiddleRow">
                    <Col sm={9}>
                      <Row>
                        <Col><div class="divsd3"><span class="alignItems1">T1: {t1}</span></div></Col>
                        <Col><div class="divsd3"><span class="alignItems1">T2: {t2}</span></div></Col>
                        <Col><div class="divsd3"><span class="alignItems1">T3: {t3}</span></div></Col>
                      </Row>
                      <Row>
                        <Col><div class="divsd3"><span class="alignItems1">T4: {t4}</span></div></Col>
                        <Col><div class="divsd3"><span class="alignItems1">T5: {t5}</span></div></Col>
                        <Col><div class="divsd3"><span class="alignItems1">T6: {t6}</span></div></Col>
                      </Row>
                    </Col>
                    <Col sm={3}>
                      <div class="divsd"><span class="alignItems1">Display TimeZone - {store.getState().localTimeZone}</span></div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

      </div>

    )
  }
}

export default CurrencyBoard
